<template>
  <div class="Box">
    <div class="top">
      <div class="top_left">
        <div class="topImg">
          <img class="img" src="../assets/logo_big.png" />
        </div>
        <p class="toptext">智慧运维管理平台</p>
      </div>
      <!-- <div class="top_right" @click="onToDownload()">资源下载</div> -->
    </div>
    <div class="login" @keydown.enter="handleSubmit">
      <!-- <img src="" class="login_img_box" alt="" /> -->
      <div class="loginContainer">
        <!--  <div class="logoArea">
          <img :src="mainlogo" class="logo" />
          <p class="slogen">{{ titles }}</p> 
          <p class="slogen"></p>
        </div> -->
        <div class="loginBox" v-if="flag == 2 ? false : true">
          <div class="loginImg">
            <img
              src="../assets/img/qrLogin.png"
              alt="二维码登录"
              title="二维码登录"
              v-show="loginCut == 1"
              @click="onLoginCut(2)"
            />
            <img
              src="../assets/img/pcLogin.png"
              alt="账号登录"
              title="账号登录"
              v-show="loginCut == 2"
              @click="onLoginCut(1)"
            />
          </div>
          <div style="padding-top: 20px">
            <div class="switchType">
              <!-- <img src alt /> -->
              <span class="loginType" v-show="loginCut == 1">账号登录</span>
              <!-- <span class="switchBorder"></span>  -->
              <!-- <img src="" alt="">  -->
              <span class="loginType" v-show="loginCut == 2">微信扫码登录</span>
            </div>
            <div class="loginCont">
              <div class="qrCodeLogin" v-show="loginCut == 2">
                <div class="qrCode_img">
                  <div
                    class="refresh_img"
                    v-show="!qrPastDue"
                    @click="getQRCode()"
                  >
                    <Icon type="ios-refresh" size="72" color="#000" />
                    <span>二维码已失效，点击刷新</span>
                  </div>
                  <img :src="qrcodeUrl" alt="二维码" class="qr_img" />
                  <span v-show="qrPastDue">{{ this.times }}秒后失效</span>
                  <span v-show="qrText" style="color: red">{{ qrText }}</span>
                </div>
              </div>
              <Form
                ref="loginForm"
                :model="form"
                :rules="rules"
                v-show="loginCut == 1"
              >
                <FormItem prop="username">
                  <div class="inputBox hasIcon">
                    <input
                      maxlength="50"
                      v-model="form.username"
                      type="text"
                      placeholder="请输入手机号/帐号"
                    />
                    <Icon type="md-phone-portrait" class="backIcon" />
                  </div>
                </FormItem>
                <FormItem prop="password">
                  <div class="inputBox hasIcon">
                    <!-- <input
                      type="password"
                      v-model="form.password"
                      placeholder="请输入密码"
                      autocomplete="new-password"
                      name="fake_password_field"
                    /> -->
                    <VirtualPwdInput v-model="form.password" />
                    <Icon type="md-lock" class="backIcon" />
                  </div>
                </FormItem>
                <FormItem prop="code" v-if="captchaOnOff">
                  <img
                    :src="verifyimg"
                    alt=""
                    class="veriImg"
                    @click="authCaptchaImage"
                  />
                  <div class="inputBox veriCode">
                    <input
                      type="text"
                      v-model="form.code"
                      placeholder="验证码"
                    />
                  </div>
                </FormItem>
                <FormItem>
                  <Button
                    size="large"
                    :loading="sloading"
                    @click="handleSubmit"
                    type="primary"
                    long
                    >登录</Button
                  >
                </FormItem>
              </Form>
            </div>
            <p class="bottomTip" v-if="false">© 赏金</p>
          </div>
        </div>
      </div>
      <!-- <div class="bottoms">医维保V1.0 &emsp; @通过ISO27001信息安全认证</div> -->
    </div>
    <div class="bottom">
      <div class="left">
        <p class="lefttext lefttext1">
          苏州华慷医疗科技有限公司 @ 通过ISO27001信息安全认证
        </p>
        <p class="lefttext">售前：18015525715 售后：18116421007</p>
      </div>
      <div class="right">
        <img class="img" src="../assets/img/ma.jpg" alt="" />
      </div>
    </div>
    <Modal
      v-model="passwordModal"
      title="密码已过期，请修改密码！"
      :show-cancel="false"
      :mask-closable="false"
      :closable="false"
    >
      <div>
        <div class="password_item">
          <div class="password_item_left">旧密码：</div>
          <div class="inputBox password_item_right">
            <VirtualPwdInputEdit
              placeholderValue="请输入旧密码"
              v-model="oldPassword"
            />
          </div>
          <!-- <Input
            v-model="oldPassword"
            type="password"
            password
            placeholder="请输入旧密码"
            autocomplete="new-password"
            :name="'pwd_' + Date.now()"
            style="width: 200px"
          /> -->
        </div>
        <div class="password_item">
          <div class="password_item_left">新密码：</div>
          <div class="inputBox password_item_right">
            <VirtualPwdInputEdit
              placeholderValue="请输入新密码"
              v-model="newPassword"
            />
          </div>
          <!-- <Input
            v-model="newPassword"
            type="password"
            password
            placeholder="请输入新密码"
            style="width: 200px"
          /> -->
        </div>
        <div class="password_item">
          <div class="password_item_left">确认密码：</div>
          <div class="inputBox password_item_right">
            <VirtualPwdInputEdit
              placeholderValue="请输入新密码"
              v-model="enterPassword"
            />
          </div>
          <!-- <Input
            v-model="enterPassword"
            type="password"
            password
            placeholder="请输入新密码"
            style="width: 200px"
          /> -->
        </div>
      </div>
      <template slot="footer">
        <div>
          <Button type="primary" @click="onEntersubmit">确定</Button>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import * as dd from "dingtalk-jsapi"; // 此方式为整体加载，也可按需进行加载
import config from "@/../config";
import VirtualPwdInput from "./VirtualPwdInput.vue";
import VirtualPwdInputEdit from "./VirtualPwdInputEdit.vue";
export default {
  data() {
    return {
      loginCut: 1,
      flag: "",
      env_type: config.env_type,
      titles: config.title,
      logo: config.logo,
      mainlogo: config.mainlogo,
      sloading: false,
      verifyimg: "",
      customerId: "",
      captchaOnOff: false,
      times: 120,
      timer: "",
      QRcodeTime: "",
      form: {
        username: "",
        password: "",
        code: "",
        uuid: "",
      },
      isQrcode: "",
      qrcodeUrl: "",
      qrPastDue: true,
      qrText: "",
      rules: {
        username: [
          { required: true, message: "账号不能为空", trigger: "blur" },
        ],
        password: [
          { required: true, message: "密码不能为空", trigger: "blur" },
        ],
        code: [
          {
            required: this.captchaOnOff ? true : false,
            message: "验证码不能为空",
            trigger: "blur",
          },
        ],
      },
      passwordModal: false,
      oldPassword: "",
      newPassword: "",
      enterPassword: "",
      oldToken: "",
      customerId: "",
    };
  },
  components: { VirtualPwdInput, VirtualPwdInputEdit },
  async created() {
    this.$bus.$off("zuoxi");
    //修改成后端构造请求连接后，token直接清除即可不用判断，不需要再判断code，登录直接在app.vue里面
    global.$utils.data.set("", "token", "");
    if (this.loginCut == 2) {
      this.getQRCode();
    }
    // this.authCaptchaImage(); //获取验证码
  },
  methods: {
    onEntersubmit() {
      if (!this.oldPassword) {
        $utils.toast.success("请输入旧密码！");
        return;
      }
      if (!this.newPassword) {
        $utils.toast.success("请输入新密码！");
        return;
      }
      if (!this.enterPassword) {
        $utils.toast.success("请再次输入新密码！");
        return;
      }
      let passwordReg = /^(?=.*[a-zA-Z])(?=.*\d).{6,32}$/;
      let passwordChk = passwordReg.test(this.newPassword);
      if (!passwordChk) {
        return $utils.toast.error(
          "密码至少包含字母，数字，且不少于6位，不大于32位！"
        );
      }
      if (this.newPassword != this.enterPassword) {
        $utils.toast.success("确认密码错误，请重新输入！");
        return;
      }
      let q = {
        oldPassword: this.oldPassword,
        newPassword: this.newPassword,
        confirmPassword: this.enterPassword,
        userId: this.userId,
      };

      $utils.api
        .load("/admin/system/user/updatePwd", q, "post")
        .then((res) => {
          if (res.code == 200) {
            this.form.password = "";
            $utils.toast.success("修改成功");
            this.passwordModal = false;
          } else {
            $utils.toast.error(res.msg);
          }
        })
        .catch((err) => {
          $utils.toast.error(err.message || "修改失败，请重试");
        });
    },
    onLoginCut(val) {
      this.loginCut = val;
      if (val == 2) {
        this.getQRCode();
      } else if (val == 1) {
        clearInterval(this.timer);
        clearInterval(this.QRcodeTime);
      }
    },
    onTimer() {
      this.timer = setInterval(() => {
        this.times = this.times - 1;
        if (this.times == 0) {
          clearInterval(this.timer);
          clearInterval(this.QRcodeTime);
          this.qrPastDue = false;
        }
      }, 1000);
    },
    async getQRCode() {
      let d = {};
      let res = await $utils.api.load("admin/create/qrcode", d, "get");
      if (res.code == 200) {
        this.qrcodeUrl = config.IMAGE_HOST + res.data.url;
        this.isQrcode = res.data.isQrcode;
        this.qrPastDue = true;
        this.qrcodeId = res.data.qrcodeNo;
        this.times = 120;
        this.qrText = "";
        this.QRcodeTime = setInterval(() => {
          this.getQrcodeLogin();
        }, 1000);
        this.onTimer();
      }
    },
    async getQrcodeLogin() {
      let d = {
        qrcodeNo: this.qrcodeId,
      };
      let res = await $utils.api.load(
        "admin/create/qrcodeLogin",
        this.qrcodeId,
        "post",
        {
          toasterror: false,
        }
      );
      if (res.code == 200) {
        if (res.isQrcode == 2) {
          clearInterval(this.timer);
          clearInterval(this.QRcodeTime);
          $utils.toast.text(res.msg);
          const last_login_time = $utils.time.format(res.user.loginDate || "");
          $utils.data.set("auth", "last_login_time", last_login_time);
          $utils.data.set("auth", "auths", []);
          $utils.data.set("auth", "username", res.user.nickName);
          $utils.data.set("auth", "userName", res.user.userName);
          $utils.data.set("auth", "suid", res.user.userId);
          $utils.data.set("auth", "uid", res.user.userId);
          $utils.data.set("auth", "uname", res.user.nickName);
          window.localStorage.setItem("userId", res.user.userId);
          $utils.data.set(
            "auth",
            "avatar",
            $utils.image.load(res.user.avatar) ||
              require("@/assets/img/useravatar.jpg")
          );
          $utils.data.set("auth", "auths", res.auths);
          window.localStorage.setItem("customerId", res.user.customerId);
          // $utils.data.set('auth', 'is_system', res.data.is_admin)
          // $utils.data.set('auth', 'is_admin', res.data.is_admin)
          // $utils.data.set('auth', 'is_all_order', res.data.is_all_order)
          // $utils.data.set('auth', 'shop_id', res.data.shop_id)
          // $utils.data.set('auth', 'shop_name', res.data.shop_name)
          // 强制刷新页面 否则左侧路由无法更新
          this.$store.commit("updateMenulist");
          // if (res.makeMain == "1"){
          $utils.url.push({ path: "/index" });
          // $utils.url.push({ path: "/allIndex" });
          // }else if (res.makeMain == "2"){
          //   $utils.url.push({ path: "/workOrder_weixiu" });
          // }else if (res.makeMain == "3"){
          //   $utils.url.push({ path: "/workOrder_cus" });
          // }

          // window.location.reload(true);
        }
      } else {
        this.qrText = res.msg;
      }
    },
    // reVerifyimg() {
    //   this.verifyimg = $utils.config.API_HOST + `/admin/captchaImage?cid=ADMIN_LOGIN&a=${Math.random().toFixed(2)}`
    // },
    handleSubmit() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.ajaxLogin(
            this.form.username,
            this.form.password,
            this.form.code,
            this.form.uuid
          );
        }
      });
    },
    authCaptchaImage() {
      let q = {};
      $utils.api
        .load("authCaptchaImage", q, "get", {
          toast: false,
          toasterror: false,
          loading: false,
          loadingtext: "Loading",
          login: false,
        })
        .then((res) => {
          if (res.code == 200) {
            this.captchaOnOff = res.captchaOnOff;
            this.verifyimg = "data:image/gif;base64," + res.img;
            this.form.uuid = res.uuid;
          } else {
            $utils.toast.error(res.msg);
          }
        })
        .catch((err) => {
          this.sloading = false;
        });
    },
    ajaxLogin(username, password, code) {
      let q = {};
      q.username = username;
      q.password = password;
      q.code = code;
      q.uuid = this.form.uuid;
      this.sloading = true;
      $utils.api
        .load("authLogin", q, "post", {
          toast: false,
          toasterror: false,
          loading: false,
          loadingtext: "Loading",
          login: false,
        })
        .then((res) => {
          this.sloading = false;
          if (res.code == 200) {
            if (!res.updatePwd) {
              $utils.toast.text(res.msg);
              const last_login_time = $utils.time.format(
                res.user.loginDate || ""
              );
              $utils.data.set("auth", "last_login_time", last_login_time);
              $utils.data.set("auth", "auths", []);
              $utils.data.set("auth", "username", res.user.nickName);
              $utils.data.set("auth", "userName", res.user.userName);
              $utils.data.set("auth", "suid", res.user.userId);
              $utils.data.set("auth", "uid", res.user.userId);
              $utils.data.set("auth", "uname", res.user.nickName);
              window.localStorage.setItem("userId", res.user.userId);
              $utils.data.set(
                "auth",
                "avatar",
                $utils.image.load(res.user.avatar) ||
                  require("@/assets/img/useravatar.jpg")
              );
              $utils.data.set("auth", "auths", res.auths);
              window.localStorage.setItem("customerId", res.user.customerId);
              // $utils.data.set('auth', 'is_system', res.data.is_admin)
              // $utils.data.set('auth', 'is_admin', res.data.is_admin)
              // $utils.data.set('auth', 'is_all_order', res.data.is_all_order)
              // $utils.data.set('auth', 'shop_id', res.data.shop_id)
              // $utils.data.set('auth', 'shop_name', res.data.shop_name)
              // 强制刷新页面 否则左侧路由无法更新
              this.$store.commit("updateMenulist");
              // if (res.makeMain == "1"){
              $utils.url.push({ path: "/index" });
              // $utils.url.push({ path: "/allIndex" });
              // }else if (res.makeMain == "2"){
              //   $utils.url.push({ path: "/workOrder_weixiu" });
              // }else if (res.makeMain == "3"){
              //   $utils.url.push({ path: "/workOrder_cus" });
              // }

              // window.location.reload(true);
            } else {
              window.localStorage.setItem("updatePwd", res.updatePwd);
              this.userId = res.user.userId;
              this.passwordModal = true;
            }
          } else {
            this.authCaptchaImage();
            $utils.toast.error(res.msg);
          }
        })
        .catch((err) => {
          this.sloading = false;
        });
    },
    onToDownload() {
      $utils.url.push({ name: "fileDownloadList" });
    },
  },
};
</script>

<style lang="less" scoped>
.Box {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  background: url("../assets/img/login_bg.png") no-repeat;
  background-size: 100% 100%;

  .top {
    margin: 8px 0;
    margin-top: 2%;
    height: 45px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    .top_left {
      height: 45px;
      display: flex;
      width: 50%;
      align-items: center;
      margin-left: 8%;
    }

    .top_right {
      margin-right: 8%;
      padding-top: 5px;
      color: #000;
      font-size: 18px;
    }

    .topImg {
      // margin-left: 8%;
      // width: 180px;
      height: 45px;

      .img {
        // width: 100%;
        // max-width: 100%;
        /* 最大宽度为其父容器的100% */
        height: 100%;
        width: auto;
      }
    }

    .toptext {
      margin-left: 20px;
      // padding-top: 5px;
      color: #000;
      // font-size: 18px;
      font-size: calc((100vw / 100 - 100vw / 1000) * 1.2);
      font-weight: 800;
    }
  }

  .bottom {
    height: 120px;
    box-sizing: border-box;
    // padding-top: 10px;
    display: flex;
    justify-content: space-between;

    .left {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-top: 5px;
      margin-left: 8%;

      .lefttext1 {
        font-weight: 600;
      }

      .lefttext {
        color: #666;
        font-size: 18px;
        margin: 5px 0;
      }
    }

    .right {
      margin-right: 8%;
      margin-left: 50px;
      width: 80px;

      .img {
        width: 100%;
        max-width: 100%;
        height: auto;
      }
    }
  }
}

.loginBox {
  width: 400px;
  height: 360px;
  background-color: #fff;
  padding: 40px 50px;
  border: 1px solid #efefef;
  border-radius: 10px;
  right: 15%;
  position: absolute;

  .loginImg {
    position: absolute;
    right: -1px;
    top: -1px;
    padding: 8px;
    // border-radius: 10px;
    border-bottom-left-radius: 10px;
    border-left: 1px solid #d7d4d4;
    border-bottom: 1px solid #d7d4d4;
    display: flex;
    box-sizing: border-box;
  }
}

.login {
  width: 100%;
  position: relative;
  font-size: 0;

  height: calc(100% - 240px);
  // min-height: 300px;
  // background-image: url("../assets/img/login_bg.png");
  // background-repeat: no-repeat;
  // background-position: center 110px;
  // background-size: 100% 100%;
  // position: relative;

  // background-color: #f0f2f5;

  .login_img_box {
    width: 100%;
  }

  &-infor {
    height: 135px;
    width: 240px;
    margin: 0 auto;

    .made-child-con-middle {
      height: 100%;
    }
  }

  &-logo {
    display: block;
    width: 90%;
    max-width: 100px;
    height: auto;
  }

  &-title {
    font-size: 2em;
    color: #2d8cf0;
  }

  &-stitle {
    font-size: 1.2em;
  }

  &-con {
    position: relative;
    // right: 160px;
    top: 45%;
    transform: translateY(-60%);
    width: 368px;
    margin: 0 auto;

    &-header {
      font-size: 16px;
      font-weight: 300;
      text-align: center;
      padding: 30px 0;
    }

    .form-con {
      padding: 10px 0 0;
    }

    .login-tip {
      font-size: 10px;
      text-align: center;
      color: #c3c3c3;
    }
  }
}

.password_item {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  .password_item_left {
    width: 80px;
  }
  .password_item_right {
    width: 70%;
  }
}

.ivu-btn-primary {
  color: #fff;
  background-color: #2d8cf0;
  border-color: #2d8cf0;
}

.logoArea {
  // position: absolute;
  width: 60%;
  // margin-top: -60px;
  // top: 6%;
  // text-align: center;
  // left: 0
}

.logo {
  width: 160px;
  height: 60px;
  cursor: pointer;
  margin-left: 30%;
}

.slogen {
  font-size: 28px;
  line-height: 1.25;
  // text-align: center;
  color: #fff;
  font-family: microsoft yahei;
  margin-top: 10px;
  margin-left: 30%;
  font-weight: bold;
}

.loginContainer {
  // position: absolute;
  position: absolute;
  left: 0;
  top: 0;
  min-height: 320px;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  //   align-items: center;
  flex-direction: column;
}

.xiaoeDesc {
  width: 285px;
  line-height: 20px;
  font-family: PingFangSC;
  font-size: 14px;
  letter-spacing: -0.2px;
  text-align: center;
  color: #b2b2b2;
  position: absolute;
  bottom: 30px;
  left: 50%;
  margin-left: -142px;
}

.xiaoeDesc:after,
.xiaoeDesc:before {
  content: "";
  position: absolute;
  border-bottom: 2px solid #bbb;
  width: 30px;
  top: 9px;
  right: 0;
}

.xiaoeDesc:before {
  right: auto;
  left: 0;
}

.veriImg {
  float: right;
  width: 100px;
  height: 36px;
  border: 1px solid #eee;
}

.switchType {
  text-align: center;
  height: 22px;
  line-height: 22px;
}

.switchType img {
  height: 18px;
  width: auto;
  vertical-align: middle;
  cursor: pointer;
}

.switchType .loginType {
  font-size: 16px;
  color: #b2b2b2;
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
}

.switchType .loginType {
  color: #353535;
}

.switchType .switchBorder {
  width: 2px;
  height: 18px;
  background-color: #d8d8d8;
  margin: 0 16px;
  display: inline-block;
  vertical-align: middle;
}

.loginCont {
  padding: 32px 0 0;

  .qrCode_img {
    display: flex;
    flex-direction: column;
    align-items: center;

    .refresh_img {
      width: 180px;
      height: 180px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      background: rgba(255, 255, 255, 0.9);
      position: absolute;
      z-index: 2;

      span {
        font-size: 14px;
      }
    }

    .qr_img {
      width: 180px;
      height: 180px;
      margin-bottom: 10px;
    }

    span {
      font-size: 16px;
    }
  }
}

.bottomTip {
  font-size: 12px;
  color: #353535;
  text-align: center;
  margin: 0;
  margin-top: 30px;
}

.bottoms {
  font-size: 16px;
  color: #fff;
  text-align: center;
  margin-block-end: 10%;
}

.veriCode {
  width: 180px;
}

.veriImg {
  float: right;
  width: 100px;
  height: 36px;
}

.loginOperate {
  font-size: 12px;
  line-height: 14px;
}

.loginOperate label {
  line-height: 14px;
  height: 14px;
  font-size: 12px;
  color: #b2b2b2;
}

.loginOperate a {
  color: #b2b2b2;
}

.loginOperate a:hover {
  color: #2a75ed;
}

.wxLogin {
  text-align: center;
}

.wxLogin #login_container {
  width: 200px;
  height: 200px;
  display: block;
  margin: 0 auto;
}

.wxLogin .wxTip {
  margin: 0;
  text-align: center;
  margin-top: 10px;
  font-size: 12px;
  color: #353535;
}

.wxLogin .wxAlert {
  font-size: 12px;
  text-align: center;
  color: #fb6161;
  margin-top: 10px;
  margin-bottom: 0;
  display: none;
}

.wxLogin .wxAlert.active {
  display: block;
}

.wxLoginFaild {
  text-align: center;
}

.wxLoginFaild img {
  width: 60px;
  margin-top: 60px;
  height: 60px;
}

.wxLoginFaild .title {
  font-size: 16px;
  color: #353535;
  margin: 20px 0 10px;
  font-weight: 700;
}

.wxLoginFaild .cont {
  font-size: 14px;
  margin: 0;
}

.wxLoginFaild button {
  margin-top: 77px;
}

div.inputBox {
  height: 36px;
  position: relative;
}

div.inputBox:focus {
  border: 1px solid #000;
}

div.inputBox.hasIcon {
  background-size: 12px auto;
  background-position: left 10px center;
  background-repeat: no-repeat;
}

div.inputBox.hasIcon input {
  text-indent: 38px;
}

div.inputBox .backIcon {
  position: absolute;
  font-size: 20px;
  width: 22px;
  left: 10px;
  top: 6px;
  color: #888;
}

div.inputBox input {
  font-size: 14px;
  border: none;
  outline: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  width: 100%;
  line-height: 34px;
  height: 36px;
  display: block;
  text-indent: 10px;
  position: absolute;
  left: 0;
  top: 0;
  border-radius: 2px;
  border: 1px solid #eee;
  background: transparent;
  -webkit-transition: all 0.2s linear;
  transition: all 0.2s linear;
}

div.inputBox input:focus {
  border: 1px solid #2a75ed;
}

div.inputBox.alert input {
  border-color: #fb6161;
}

div.inputBox.alert + .inputAlert {
  display: block;
  color: #fb6161;
  font-size: 12px;
  margin: 0;
  line-height: 12px;
  margin-top: -22px;
  margin-bottom: 10px;
  position: absolute;
}

div.inputBox.alert + .inputAlert.hasTitle {
  margin-left: 66px;
}

div.inputBox + .inputAlert {
  display: none;
}

a {
  text-decoration: none;
  color: #2a75ed;
  font-size: 12px;
}

button.btn {
  width: 100%;
  height: 36px;
  border-radius: 2px;
  font-size: 14px;
  line-height: 36px;
  border: none;
  cursor: pointer;
  margin-top: 10px;
}

button.btn.blue {
  color: #fff;
  background-color: #2a75ed;
}

button.btn.grey {
  background-color: #f5f7fa;
  border: 1px solid #e5e7ea;
  color: #666;
}

button.btn.opacity {
  opacity: 0.3;
  outline: none;
}
</style>
